import MToggle from "./MToggle.vue";
export default MToggle;
export type { MToggleProps } from "./MToggle.props";
